module.exports = __webpack_public_path__ + "img/eyebrow_male_arched_thin_mask.1024f686.png";